import React, { useCallback, useEffect, useMemo, useState } from 'react'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBack'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { useVisualBlocksContext } from '../VisualBlocksContext'
import SectionedBar from '../../../../VisualBalanceSheetV2/SectionedBar'
import DrilldownTable from './DrilldownTable'

const useStyles = makeStyles(() => ({
  topContainer: {
    marginBottom: '16px'
  },
  tableContainer: {
    marginTop: '32px'
  }
}))

export const BlockDrilldown = () => {
  const classes = useStyles()
  const {
    ddItem,
    setDdItem,
    ddVariablesContext,
    setDdVariablesContext,
    setFilterTable,
    ddPipeline,
    drilldownKeyAccessor,
    ddFilterKey,
    labels
  } = useVisualBlocksContext()
  const clearData = () => {
    setDdItem(null)
    setFilterTable(null)
  }
  const [selectedBlockId, setSelectedBlockId] = useState(undefined)
  const onClickBlock = useCallback((block) => {
    if (block?.selectKey === selectedBlockId) {
      setSelectedBlockId(null)
      setFilterTable(null)
    } else {
      setSelectedBlockId(block?.selectKey)
      setFilterTable(block.selectKey)
    }
  }, [selectedBlockId, setSelectedBlockId, setFilterTable])
  const sectionBarData = ddItem.details.map(item => ({
    endingValue: item.value,
    accountName: item.name,
    selectKey: item[drilldownKeyAccessor] ?? ''
  }))
  const backgroundColor = ddItem.color
  const simplifiedColor = useMemo(() => {
    if (!backgroundColor) return '#eee'
    if (backgroundColor.indexOf('gradient') >= 0) {
      const colorMatches = backgroundColor.match(/(rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|#[0-9a-fA-F]{3,6})/g) || []

      for (const color of colorMatches) {
        if (color !== 'rgb(255, 255, 255)' && color.toLowerCase() !== '#ffffff' && color.toLowerCase() !== '#fff') {
          return color
        }
      }
    }
    return backgroundColor
  }, [backgroundColor])
  const [selectedIds] = useState(ddItem.data.map(item => item[drilldownKeyAccessor]))
  useEffect(() => {
    setDdVariablesContext(prev => ({
      ...prev,
      filters: {
        ...(prev?.filters || {}),
        [ddFilterKey]: selectedIds
      }
    }))
  }, [ddFilterKey, selectedIds, setDdVariablesContext])

  return (
    <div
      className={classes.blockChart}
    >
      <div className={classes.topContainer}>
        <div onClick={clearData} className={clsx(classes.backButton, 'flex gap-sm items-center')}>
          <ArrowBackOutlinedIcon />
          {!!labels?.drilldownBackButton?.length && <div className='font-size-md'>{labels.drilldownBackButton}</div>}
        </div>
      </div>
      <SectionedBar
        backgroundColor={simplifiedColor}
        blocks={sectionBarData}
        titleFormat='0.00a'
        selectedBlockId={selectedBlockId}
        useStripedBackground={ddItem.isSeparated}
        selectKey='selectKey'
        onClick={(item) => onClickBlock(item)}
      />
      <div className={classes.tableContainer}>
        {!!ddVariablesContext?.filters?.[ddFilterKey] && !!ddPipeline?.length && <DrilldownTable />}
      </div>
    </div>
  )
}
